import React from "react";

const OrderItem = ({ e }) => {
	return (
		<div className="w-full md:px-6 p-4 border border-gray-100 bg-white rounded-2xl transition-all">
			<div className="flex justify-between items-start mb-3">
				<h5 className="state font-semibold text-[#FFB7CF] tracking-wide px-3 py-1 text-xs bg-[#fff1f5] rounded-full capitalize">
					{e?.status}
				</h5>
			</div>

			<div className="order-item w-full">
				<div className="order-item-in w-full">
					<div className="flex flex-col sm:flex-row w-full justify-between sm:items-center gap-4">
						<div className="left flex gap-x-4 items-center">
							<div className="image bg-gray-50 rounded-xl overflow-hidden h-16 w-16 md:h-20 md:w-20 shadow-sm flex-shrink-0">
								<img
									src={e?.images[0]}
									alt=""
									className="w-full h-full object-cover"
								/>
							</div>
							<div className="text-sm flex-1 min-w-0">
								<h4 className="Item-name font-bold text-gray-900 text-base md:text-lg truncate">{e?.name}</h4>
								<h6 className="item text-gray-500 text-xs md:text-sm truncate max-w-[200px] md:max-w-[300px]">
									{e?.description}
								</h6>
								<div className="colors gap-x-2 text-xs flex font-medium mt-2">
									<span className="bg-gray-100 text-gray-600 px-2 py-1 rounded-md">
										Glossy
									</span>
									<span className="bg-gray-100 text-gray-600 px-2 py-1 rounded-md">
										{e?.color}
									</span>
									<div className="color-picked w-6 h-6 rounded-full border border-gray-200 shadow-inner" style={{ backgroundColor: e?.color || 'black' }}></div>
								</div>
							</div>
						</div>
						<div className="right flex sm:flex-col items-center sm:items-end justify-between sm:justify-center gap-2 text-sm mt-2 sm:mt-0 pt-3 sm:pt-0 border-t sm:border-t-0 border-gray-100">
							<span className="amount text-gray-500 font-medium bg-gray-50 px-3 py-1 rounded-lg">
								Qty: {e?.quantity}
							</span>
							<span className="cost text-gray-900 font-bold text-lg">
								${e?.final_price}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OrderItem;
